import type { WikiPage } from '../stores/wiki_pages'

// Pure helpers behind the Today page header.

const MORNING_ENDS_AT = 12
const AFTERNOON_ENDS_AT = 18

/** "Good morning." / "Good afternoon." / "Good evening." for the given time. */
export function todayGreeting(now: Date): string {
  const hour = now.getHours()
  if (hour < MORNING_ENDS_AT) return 'Good morning.'
  if (hour < AFTERNOON_ENDS_AT) return 'Good afternoon.'
  return 'Good evening.'
}

// DailyBriefingJob archives each briefing as summaries/daily-YYYY-MM-DD.md.
const BRIEFING_PATH = /^summaries\/daily-(\d{4}-\d{2}-\d{2})\.md$/

/** The newest archived daily briefing page in the catalog, or null. */
export function latestBriefingPage(pages: WikiPage[]): WikiPage | null {
  let latest: { page: WikiPage; date: string } | null = null
  for (const page of pages) {
    const date = BRIEFING_PATH.exec(page.path)?.[1]
    if (date && (!latest || date > latest.date)) latest = { page, date }
  }
  return latest?.page ?? null
}
